import BlNavBarMv from './BlNavBarMv.vue'

BlNavBarMv.install = function(Vue) {
  Vue.component(BlNavBarMv.name, BlNavBarMv)
}

export default BlNavBarMv
